import Login from "../User/Login";
import Register from "../User/Register";
import User from "../User/User";

const { createBrowserRouter } = require("react-router-dom");
const { default: App } = require("../../App");

export const routes = createBrowserRouter([
    {
        path: '/',
        element: <App></App>,
        children: [
            {
                index: true,
                element: <User></User>
            },
            {
                path: 'user',
                element: <User></User>
            },
            {
                path: 'login',
                element: <Login></Login>,
            },
            {
                path: 'register',
                element: <Register></Register>,
            }
        ]
    }
])